import deviceInfo from "~/utils/device";
import request from "@ky/sdk/dist/request";
import { checkMobile } from "../../checkPermission";
import ToastModal from "../../modal/toastModal.vue";
import open from "@ky/sdk/dist/open";
import { KLING_HOME_CREATE } from "../../constants";
import Cookies from "js-cookie";

const toastModal = new ApiModal<typeof ToastModal>(ToastModal, null, {
  sync: true,
});

/** sdk 中 getCookie 取不到，但是js-cookie可以取到，这里先用js-cookie */
export const getCommonCookieParams = () => {
  const did = Cookies.get("did") || Cookies.get("_did");
  return {
    webId: did,
    userId: Cookies.get("userId"),
    "ky.api_st": Cookies.get("ky.api_st"),
  };
};

request.interceptors.response.use(
  (response: any) => {
    return response;
  },
  async (e: any) => {
    if (e.result === 109) {
      // 移动端端外不自动拦截登录跳转
      const url = e.loginUrl;
      if (!deviceInfo.isPC) {
        await checkMobile();
        return Promise.reject(e);
      }
      window.location.href = url;
      return Promise.reject(null);
    } else if (e.result === 154037) {
      // 无可灵权限
      await new Promise((resolve, reject) => {
        toastModal?.show({
          type: "permission",
          autoClose: false,
          toastSmall: true,
          onClose: () => {
            reject();
          },
          onConfirm: () => {
            reject(null);
            if (deviceInfo.isKy) {
              open(
                `kwaiying://krn?bundleId=KyAIAggregation&componentName=applyAiVideo`,
              );
            } else {
              window.open(KLING_HOME_CREATE);
            }
          },
        });
        reject();
      });
      return Promise.reject(null);
    } else if (e.result === 154004) {
      await new Promise((resolve, reject) => {
        toastModal?.show({
          type: "error",
          desc: `参与投稿需绑定快手账号，请前往设置进行绑定`,
          onClose: () => {
            reject();
          },
          onConfirm: () => {
            open(`kwaiying://setting`);
            reject(null);
          },
        });
        reject();
      });
      return Promise.reject(null);
    }
    return Promise.reject(e);
  },
);

// request.interceptors.request.use((config: any) => {
//   const baseURL = process.env.VITE_KLING_API_HOST;
//   if (baseURL) config.baseURL = baseURL;
//   return config;
// });

export interface PageUI {
  /** 奖项列表 */
  rewards: Array<{
    /** 赛道
     *
     * - expertReview 专家评审通道
     * - kuaishouPopularity 快手人气
     */
    contestChannel: "expertReview" | "kuaishouPopularity";
    title: string;
    /**
     * - 1 一等奖
     * - 2 二等奖
     * - 3 三等奖
     * - 4 优秀奖
     */
    code: 1 | 2 | 3 | 4;
    /** 奖项名额 */
    count: number;
    /** 描述 */
    description: string;
    iconUrls: string[];
  }>;
  /** 评委列表 */
  reviewers: Array<{
    /** 评委照片url */
    photoUrl: string;
    /** 名字 */
    name: string;
    /** 描述 */
    description: string;
  }>;
  /** 规则 */
  ruleDesc: string;
  /** 话题 */
  topics: string[];
  showSubmitPage: boolean;
}

/** 活动页面素材下发 */
export const getPageUI = () => {
  return request.get("/rest/n/kmovie/app/activity/kling/pageUI") as Promise<{
    result: number;
    data: PageUI;
    errorMsg?: string;
  }>;
};

export interface PublishListItem {
  /** id */
  id: number;
  /** 快手作品链接 */
  photoUrl: string;
  photoId: number;
  /** 快手用户名 */
  ksNickName: string;
  /** 快影头像url */
  iconUrl: string;
  /** 作品封面url */
  coverUrl: string;
  /** 视频url */
  videoUrl: string;
  /** 视频宽 */
  vedioWeight: number;
  /** 视频高 */
  vedioHeight: number;
}

export const getPublishList = (params: {
  /**
   * - all 全部作品
   * - remarked 精选作品
   * - mine 我的作品
   */
  type: "all" | "remarked" | "mine";
  /** 分页码，从第几个开始获取，非id，一页10支持服务端配置 */
  pcursor: number;
}) => {
  const { type } = params ?? {};
  const path =
    type === "mine"
      ? deviceInfo?.isPC
        ? `/rest/n/kmovie/app/activity/kling/pc/getMyPublishList`
        : `/rest/n/kmovie/app/activity/kling/getMyPublishList`
      : `/rest/n/kmovie/app/activity/kling/getPublishList`;
  return request.get(path, {
    params: {
      ...params,
      __redirectURL: window.location.href,
      ...getCommonCookieParams(),
    },
  }) as Promise<{
    result: number;
    data: {
      submissionList: PublishListItem[];
      /** -1 表示已经到底 */
      pcursor: number;
    };
    errorMsg?: string;
  }>;
};

export interface SubmitContributeParams {
  /** 赛道 */
  contestChannel: "expertReview" | "kuaishouPopularity";
  /** 二级投稿通道
   * - 1 烟火人间
   * - 2 广告天才
   * - 3 灵感无限
   * - 快手人气通道传0
   */
  secondContestChannel: number;
  /** 快手作品链接 */
  photoUrl: string;
  /** 快手作品标题 */
  photoTitle: string;
  /** 快手作品描述 */
  photoDescription: string;
}

/** 投稿 */
export const submitContribute = (params: SubmitContributeParams) => {
  console.log("提交投稿：", params);
  const path = deviceInfo?.isPC
    ? `/rest/n/kmovie/app/activity/kling/pc/submit`
    : `/rest/n/kmovie/app/activity/kling/submit`;
  return request
    .post(path, params, {
      params: {
        __redirectURL: window.location.href,
        ...getCommonCookieParams(),
      },
    })
    .catch(async (e) => {
      if (!e) return Promise.reject({});
      if (e.result === 154001) {
        await new Promise((resolve, reject) => {
          toastModal?.show({
            type: "error",
            desc: "作品链接与登录账号不一致<br/>请使用你的快手账号发布作品",
            onClose: () => reject(),
            onConfirm: () => resolve(null),
          });
        });
        return Promise.reject({});
      }
      // 视频长度不够
      if (e.result === 161022) {
        await new Promise((resolve, reject) => {
          toastModal?.show({
            type: "error",
            desc: "<p>你的作品视频未满足投稿要求</p><p>请发布不低于30秒的快手作品</p>",
            onClose: () => reject(),
            onConfirm: () => resolve(null),
          });
        });
        return Promise.reject({});
      }
      await new Promise((resolve, reject) => {
        toastModal?.show({
          type: "error",
          desc: e?.errorMsg,
          onClose: () => reject(),
          onConfirm: () => resolve(null),
        });
      });
      return Promise.reject(e);
    }) as Promise<{
    /**
     * - 1 投稿成功
     * - 154_003 用户无剩余投稿次数
     * - 154_001 用户分享视频的所属快手账号非当前登录 账号
     * - 160_013 活动未开始
     * - 160_014 活动已下线
     * - 154_010 分享链接无效
     * - 154_002 用户未登录，防黑产用
     * - 154_004 可能未绑定快手账号，防黑产用
     * - 154_042 赛道不存在，防黑产用
     * - 154_037 用户无可灵权限
     * - 160_002 该赛道重复投稿
     * - 161_022 视频长度不够
     */
    result:
      | 1
      | 154_003
      | 154_001
      | 160_013
      | 160_014
      | 154_010
      | 154_002
      | 154_004
      | 154_042
      | 154_037
      | 160_002
      | 161_022;
    data: any;
    errorMsg?: string;
  }>;
};

export interface ContributeCount {
  expertReview: Array<{
    title: string;
    code: number;
    description: string;
    restSubmitCount: number;
  }>;
  kuaishouPopularity: Array<{
    title: string;
    code: number;
    description: string;
    restSubmitCount: number;
  }>;
}

export const getContributeCount = () => {
  const path = deviceInfo?.isPC
    ? `/rest/n/kmovie/app/activity/kling/pc/restSubmitCount`
    : `/rest/n/kmovie/app/activity/kling/restSubmitCount`;
  return request.get(path, {
    params: {
      __redirectURL: window.location.href,
      ...getCommonCookieParams(),
    },
  }) as Promise<{
    result: number;
    data: ContributeCount;
    errorMsg?: string;
  }>;
};

export type PublishListItemWithChannel = PublishListItem & {
  channel: number;
};

export interface RewardLevel {
  expertReview: {
    /** 烟火人间 */
    1: PublishListItem[];
    /** 广告天才 */
    2: PublishListItem[];
    /** 灵感无限 */
    3: PublishListItem[];
  };
  kuaishouPopularity: {
    /** 快手人气通道 */
    0: PublishListItem[];
  };
}

export const getRewardList = () => {
  return request.get(
    `/rest/n/kmovie/app/activity/kling/getRewardList`,
  ) as Promise<{
    result: number;
    data: {
      firstLevel: RewardLevel;
      secondLevel: RewardLevel;
      kuaishouPopularity: RewardLevel;
      canShow: boolean;
    };
  }>;
};
